import { render, staticRenderFns } from "./ImpersonateBar.vue?vue&type=template&id=2f8e65e6&scoped=true&"
import script from "./ImpersonateBar.vue?vue&type=script&lang=ts&"
export * from "./ImpersonateBar.vue?vue&type=script&lang=ts&"
import style0 from "./ImpersonateBar.vue?vue&type=style&index=0&id=2f8e65e6&prod&lang=sass&"
import style1 from "./ImpersonateBar.vue?vue&type=style&index=1&id=2f8e65e6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e65e6",
  null
  
)

export default component.exports